import Vue from 'vue'
const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.login.language,
  user: () => JSON.parse(sessionStorage.getItem("user")) || {},
  size: state => state.app.size,
  device: state => state.app.device,
  mybtns: state => state.power.mybtns,
  successCode: () => Vue.prototype.$successCode,
  changeUser: () => localStorage.getItem('changeUser')
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js